module.exports = __webpack_public_path__ + "img/cashier.2ad6f1fd.png";